import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const matches = () => typeof window !== 'undefined' && window.matchMedia?.(QUERY).matches === true;

/**
 * Whether the candidate has asked for reduced motion.
 *
 * The stylesheet already collapses every duration to 0.001ms under the media query, but
 * that only handles the animations. The flow also *waits* for exit animations before
 * switching screens, and a wait for an animation that is not playing reads as lag — so
 * the same signal has to be readable from JS. See `useLeaveThen`.
 */
export const useReducedMotion = () => {
  const [isReduced, setIsReduced] = useState(matches);

  useEffect(() => {
    const media = window.matchMedia?.(QUERY);
    if (!media) return;

    const onChange = () => setIsReduced(media.matches);
    media.addEventListener('change', onChange);

    return () => media.removeEventListener('change', onChange);
  }, []);

  return isReduced;
};
